import type { InventoryLaneProps } from './types';

export default function getNumberOfItems(content: InventoryLaneProps) {
    let noOfItemsMobile: number;
    let noOfItemsDesktop: number;

    // switch statement for mobile display
    switch (content.maxMobileBlocks) {
        case 0:
            noOfItemsMobile = 0;
            break;
        case 2:
            noOfItemsMobile = 2;
            break;
        case 4:
            noOfItemsMobile = 4;
            break;
        default:
            noOfItemsMobile = content.maxMobileBlocks;
            break;
    }

    // if statement for desktop display
    if (content.minDesktopBlocks === 4 && content.inventoryLaneBlocks.length < 4) {
        noOfItemsDesktop = 0;
    } else if (content.minDesktopBlocks === 4 && content.inventoryLaneBlocks.length === 4) {
        noOfItemsDesktop = 4;
    } else if (content.minDesktopBlocks === 4 && content.inventoryLaneBlocks.length === 6) {
        noOfItemsDesktop = 6;
    } else {
        noOfItemsDesktop = content.inventoryLaneBlocks.length;
    }

    return { noOfItemsMobile, noOfItemsDesktop };
}
